/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// import core & vendor packages below
import axios from 'axios';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Button, Modal, Form, FormControl, InputGroup } from 'react-bootstrap';

// Import components
import FormUI from 'components/UI/FormUI';

// import assets below
import './style.scss';
import { selectPatientItem, showPatient } from 'reducers/patientReducer';
import { ReactComponent as CircleXMark } from 'assets/svg/circle-xmark.svg';
import { ReactComponent as MagnifyingGlassSVG } from 'assets/svg/magnifying_glass.svg';

// main component
const ModalAssessmentEdit = ({ showModal, setShowModal, showProfile, setShowProfile }) => {
  const dispatch = useDispatch();
  const [id, setId] = useState('');
  const [userData, setUserData] = useState({
    RN: false,
    RPN: false,
    LPN: false,
    acute: false,
    prognosis: '',
    chronic: false,
    homemaker: false,
    palliative: false,
    convalescent: false,
    is_infectious: false,
    current_diagnosis: '',
    past_medical_history: '',
    surgical_procedures_and_dates: '',
    pertinent_signs_and_symptoms: [],
  });

  const [item, setItem] = useState({ condition_classified_as: '', another: 'another' });

  const { condition_classified_as } = item;

  const [levelOfCare, setLevelOfCare] = useState({ level_of_care: '', another: 'another' });

  const { level_of_care } = levelOfCare;

  const handleIsInfectious = (e) => {
    e.persist();
    setItem((prevState) => ({
      ...prevState,
      is_infectious: e.target.value,
    }));
    setUserData({ ...userData, is_infectious: e.target.value });
  };

  const handleChangeRadio = (e) => {
    e.persist();
    setItem((prevState) => ({
      ...prevState,
      condition_classified_as: e.target.value,
    }));
    setUserData({ ...userData, condition_classified_as: e.target.value });
  };

  const handleChangeRadioLevelOfCare = (e) => {
    e.persist();
    setLevelOfCare((prevState) => ({
      ...prevState,
      level_of_care: e.target.value,
    }));
    setUserData({ ...userData, level_of_care: e.target.value });
  };

  const patientProfile = useSelector(selectPatientItem);
  const patientMedicalInfo = patientProfile?.medical_information;

  const getValue = () => {
    console.log('USER DATA', userData);
    patientMedicalInfo !== null && setUserData(patientMedicalInfo);
  };

  const handleChange = (key) => (e) => {
    if (e.target.type === 'checkbox') {
      if (e.target.checked) {
        setUserData({
          ...userData,
          [key]: true,
        });
      } else {
        setUserData({
          ...userData,
          [key]: false,
        });
      }

      return;
    }

    setUserData({
      ...userData,
      [key]: e.target.value,
    });
  };

  // Submit data here
  const handleSubmit = async () => {
    userData.patientId = id;

    console.log('userData', userData);
    // return;

    // eslint-disable-next-line no-unreachable, multiline-comment-style
    await axios
      // .put('/medical_information', userData)
      .post('/medical_information', userData)
      .then((response) => {
        toast.success('Saved Medical Information');
        setTimeout(() => {
          setShowModal((prevState) => {
            return {
              ...prevState,
              isShowEdit: false,
            };
          });
          dispatch(showPatient(showProfile.profileId));
        }, 1500);
      })
      .catch((err) => {
        err.response.data.errors.map((item) => {
          toast.warning(item?.msg);
        });
      });
  };

  const handleMultipleCheckbox = (e) => {
    const { name, value, checked } = e.target;

    if (checked) {
      // eslint-disable-next-line prefer-const
      let newData = {
        details: name,
      };

      if (name === 'pain' || name === 'others') {
        newData.text = value;
      }

      const patientData = userData?.pertinent_signs_and_symptoms || [];

      const finalData = patientData.concat([newData]);

      setUserData((prev) => {
        return {
          ...prev,
          pertinent_signs_and_symptoms: finalData,
        };
      });

      return;
    }

    const minusData = userData?.pertinent_signs_and_symptoms.filter((d) => d?.details !== name);

    setUserData((prev) => {
      return {
        ...prev,
        pertinent_signs_and_symptoms: minusData,
      };
    });
  };

  const checkForValue = (type) => {
    if (!userData?.pertinent_signs_and_symptoms) return;

    return userData?.pertinent_signs_and_symptoms.some((data) => data?.details === type);
  };

  const handleChangePertinenSigns = (e) => {
    const { name, value } = e.target;

    const newData = userData?.pertinent_signs_and_symptoms.map((dd) => {
      if (dd?.details === name) {
        return {
          ...dd,
          text: value,
        };
      }

      return dd;
    });

    setUserData((prev) => {
      return {
        ...prev,
        pertinent_signs_and_symptoms: newData,
      };
    });
  };

  useEffect(() => {
    setId(showProfile.profileId);
    /* axios
      .get(`/medical_information/${showProfile.profileId}`)
      .then((response) => {
        setUserData((prev) => ({
          ...prev,
          prognosis: response.data.data?.prognosis,
          is_infectious: response.data.data?.is_infectious,
          level_of_care: response.data.data?.level_of_care,
          family_history: response.data.data?.family_history,
          current_diagnosis: response.data.data?.current_diagnosis,
          past_medical_history: response.data.data?.past_medical_history,
          personal_social_history: response.data.data?.personal_social_history,
          condition_classified_as: response.data.data?.condition_classified_as,
          pertinent_signs_and_symptoms: response.data.data?.pertinent_signs_and_symptoms,
          surgical_procedures_and_dates: response.data.data?.surgical_procedures_and_dates,
        }));
      }, [])
      .catch((err) => {
        console.log(err);
      }, []); */
  }, [patientProfile, showProfile]);

  return (
    <Modal
      onEnter={() => getValue()}
      size='lg'
      show={showModal.isShowEdit}
      onHide={() =>
        setShowModal((prevState) => {
          return {
            ...prevState,
            isShowEdit: false,
          };
        })
      }
      aria-labelledby='Assessment Edit'
      className='assessment-edit-modal'
    >
      <Modal.Body>
        <div className='assessment-edit'>
          <div className='d-flex header'>
            <p>CURRENT MEDICAL INFORMATION</p>

            <CircleXMark
              style={{ width: '2em', cursor: 'pointer' }}
              onClick={() => {
                setShowModal((prevState) => {
                  return {
                    ...prevState,
                    isShowEdit: false,
                  };
                });
                // setShowProfile({ profileId: null });
              }}
            />
          </div>
        </div>

        <FormUI>
          <Form className='edit-form'>
            <Row>
              <Col md={10}>
                <Form.Group className='mb-4 inline-group'>
                  <Form.Label>Current Diagnosis:</Form.Label>
                  <FormControl
                    type='text'
                    className='bg-grey'
                    placeholder='Enter Here'
                    value={userData?.current_diagnosis}
                    onChange={handleChange('current_diagnosis')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={10}>
                <Form.Group className='mb-4 inline-group'>
                  <Form.Label>Prognosis:</Form.Label>
                  <FormControl
                    type='text'
                    className='bg-grey'
                    placeholder='Enter Here'
                    value={userData?.prognosis}
                    onChange={handleChange('prognosis')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={10}>
                <Form.Group className='mb-4 inline-group'>
                  <Form.Label>Surgical Procedures and Dates:</Form.Label>
                  <FormControl
                    type='text'
                    className='bg-grey'
                    placeholder='Enter Here'
                    value={userData?.surgical_procedures_and_dates}
                    onChange={handleChange('surgical_procedures_and_dates')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-4'>
                  <Form.Label>Past Medical History</Form.Label>
                  <FormControl
                    as='textarea'
                    rows={1}
                    className='bg-white'
                    placeholder='Enter Here'
                    value={userData?.past_medical_history}
                    onChange={handleChange('past_medical_history')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-4'>
                  <Form.Label>Family History</Form.Label>
                  <FormControl
                    as='textarea'
                    rows={1}
                    className='bg-white'
                    placeholder='Enter Here'
                    value={userData?.family_history}
                    onChange={handleChange('family_history')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-4'>
                  <Form.Label>Personal Social History</Form.Label>
                  <FormControl
                    as='textarea'
                    rows={1}
                    className='bg-white'
                    placeholder='Enter Here'
                    value={userData?.personal_social_history}
                    onChange={handleChange('personal_social_history')}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-4 check-boxes-cont'>
                  <Form.Label>
                    Is Infectious:<span className='asterisk'> *</span>
                  </Form.Label>
                  <Form.Check
                    value='Yes'
                    type='radio'
                    aria-label='radio 1'
                    label='Yes'
                    onChange={handleIsInfectious}
                    checked={userData?.is_infectious === 'Yes'}
                  />
                  <Form.Check
                    value='No'
                    type='radio'
                    aria-label='radio 2'
                    label='No'
                    onChange={handleIsInfectious}
                    checked={userData?.is_infectious === 'No'}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-4 check-boxes-cont'>
                  <Form.Label>
                    Condition Classified as:<span className='asterisk'> *</span>
                  </Form.Label>
                  <Form.Check
                    value='Acute'
                    type='radio'
                    aria-label='radio 1'
                    label='Acute'
                    onChange={handleChangeRadio}
                    checked={userData?.condition_classified_as === 'Acute'}
                  />
                  <Form.Check
                    value='Chronic'
                    type='radio'
                    aria-label='radio 2'
                    label='Chronic'
                    onChange={handleChangeRadio}
                    checked={userData?.condition_classified_as === 'Chronic'}
                  />
                  <Form.Check
                    value='Convalescent'
                    type='radio'
                    aria-label='radio 2'
                    label='Convalescent'
                    onChange={handleChangeRadio}
                    checked={userData?.condition_classified_as === 'Convalescent'}
                  />
                  <Form.Check
                    value='Palliative'
                    type='radio'
                    aria-label='radio 2'
                    label='Palliative'
                    onChange={handleChangeRadio}
                    checked={userData?.condition_classified_as === 'Palliative'}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Group className='mb-4 multiple-checkbox-container'>
                  <Form.Label>Pertinent signs and Symptoms on Admission</Form.Label>

                  <div className='checkbox-inputs'>
                    <div className='checkbox-column'>
                      <Form.Check
                        type='checkbox'
                        name='Altered Mental Sensorium'
                        label='Altered Mental Sensorium'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Altered Mental Sensorium')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Abdominal cramp/pain'
                        label='Abdominal cramp/pain'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Abdominal cramp/pain')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Anorexia'
                        label='Anorexia'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Anorexia')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Bleeding gums'
                        label='Bleeding gums'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Bleeding gums')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Body weakness'
                        label='Body weakness'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Body weakness')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Blurring of vision'
                        label='Blurring of vision'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Blurring of vision')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Chest pain/discomfort'
                        label='Chest pain/discomfort'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Chest pain/discomfort')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Constipation'
                        label='Constipation'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Constipation')}
                      />

                      <Form.Check
                        name='Cough'
                        label='Cough'
                        type='checkbox'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Cough')}
                      />
                    </div>

                    <div className='checkbox-column'>
                      <Form.Check
                        type='checkbox'
                        name='Diarrhea'
                        label='Diarrhea'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Diarrhea')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Dizziness'
                        label='Dizziness'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Dizziness')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Dysphagia'
                        label='Dysphagia'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Dysphagia')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Dyspnea'
                        label='Dyspnea'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Dyspnea')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Dysuria'
                        label='Dysuria'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Dysuria')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Epistaxis'
                        label='Epistaxis'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Epistaxis')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Fever'
                        label='Fever'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Fever')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Frequency of urination'
                        label='Frequency of urination'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Frequency of urination')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Headache'
                        label='Headache'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Headache')}
                      />
                    </div>

                    <div className='checkbox-column'>
                      <Form.Check
                        type='checkbox'
                        name='Hematemesis'
                        label='Hematemesis'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Hematemesis')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Hematuria'
                        label='Hematuria'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Hematuria')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Hemoptysis'
                        label='Hemoptysis'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Hemoptysis')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Irritability'
                        label='Irritability'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Irritability')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Jaundice'
                        label='Jaundice'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Jaundice')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Lower extrem1ty edema'
                        label='Lower extrem1ty edema'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Lower extrem1ty edema')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Myalgia'
                        label='Myalgia'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Myalgia')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Orthopnea'
                        label='Orthopnea'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Orthopnea')}
                      />

                      <div className='with-textbox'>
                        <Form.Check
                          name='Pain'
                          label='Pain'
                          type='checkbox'
                          checked={checkForValue('Pain')}
                          onChange={handleMultipleCheckbox}
                        />

                        <FormControl
                          type='text'
                          className='textbox'
                          value={userData?.pain}
                          placeholder='Enter Here'
                          onChange={handleChange('pain')}
                          disabled={!checkForValue('Pain')}
                        />
                      </div>
                    </div>

                    <div className='checkbox-column'>
                      <Form.Check
                        type='checkbox'
                        name='Palpitations'
                        label='Palpitations'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Palpitations')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Seizures'
                        label='Seizures'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Seizures')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Skin rashes'
                        label='Skin rashes'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Skin rashes')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Stool, bloody/black tarry/mucoid'
                        label='Stool, bloody/black tarry/mucoid'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Stool, bloody/black tarry/mucoid')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Sweating'
                        label='Sweating'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Sweating')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Urgency'
                        label='Urgency'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Urgency')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Vomiting'
                        label='Vomiting'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Vomiting')}
                      />

                      <Form.Check
                        type='checkbox'
                        name='Weight loss'
                        label='Weight loss'
                        onChange={handleMultipleCheckbox}
                        checked={checkForValue('Weight loss')}
                      />

                      <div className='with-textbox'>
                        <Form.Check
                          name='Others'
                          label='Others'
                          type='checkbox'
                          checked={checkForValue('Others')}
                          onChange={handleMultipleCheckbox}
                        />

                        <FormControl
                          type='text'
                          className='textbox'
                          placeholder='Enter Here'
                          value={userData?.other_symptoms}
                          disabled={!checkForValue('Others')}
                          onChange={handleChange('other_symptoms')}
                        />
                      </div>
                    </div>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            {/* <Row>
              <Col>
                <Form.Group className='mb-4 check-boxes-cont'>
                  <Form.Label>
                    Level of care Recommended:<span className='asterisk'> *</span>
                  </Form.Label>
                  <Form.Check
                    value='RN'
                    type='radio'
                    aria-label='radio 1'
                    label='RN'
                    onChange={handleChangeRadioLevelOfCare}
                    checked={userData?.level_of_care === 'RN'}
                  />
                  <Form.Check
                    value='RPN'
                    type='radio'
                    aria-label='radio 2'
                    label='RPN'
                    onChange={handleChangeRadioLevelOfCare}
                    checked={userData?.level_of_care === 'RPN'}
                  />
                  <Form.Check
                    value='LPN'
                    type='radio'
                    aria-label='radio 2'
                    label='LPN'
                    onChange={handleChangeRadioLevelOfCare}
                    checked={userData?.level_of_care === 'LPN'}
                  />
                  <Form.Check
                    value='Homemaker'
                    type='radio'
                    aria-label='radio 2'
                    label='Homemaker'
                    onChange={handleChangeRadioLevelOfCare}
                    checked={userData?.level_of_care === 'Homemaker'}
                  />
                </Form.Group>
              </Col>
            </Row> */}

            <Row>
              <Col>
                <Form.Group className='mt-4 buttons-cont'>
                  <Button
                    className='add-button'
                    variant='primary'
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    Save
                  </Button>
                  <Button
                    className='cancel-button'
                    vvariant='secondary'
                    onClick={() => {
                      setShowModal((prevState) => {
                        return {
                          ...prevState,
                          isShowEdit: false,
                        };
                      });
                    }}
                  >
                    Cancel
                  </Button>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </FormUI>
      </Modal.Body>
    </Modal>
  );
};

export default ModalAssessmentEdit;
